// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1rKEP","gfeWrapper":"CalendarEvent_gfeWrapper__2gWjn"};